var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuentaOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / cuenta-outlined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-cuenta-outlined",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997,1.9996 C17.5227,1.9996 21.9997,6.4766 21.9997,11.9996 C21.9997,17.5226 17.5227,21.9996 11.9997,21.9996 C6.4767,21.9996 1.9997,17.5226 1.9997,11.9996 C1.9997,6.4766 6.4767,1.9996 11.9997,1.9996 Z M11.9997,17.0036 C9.8577,17.0036 7.7937,17.6016 5.9927,18.7236 C7.5907,20.1536 9.6927,21.0306 11.9997,21.0306 C14.3087,21.0306 16.4107,20.1526 18.0097,18.7216 C16.2087,17.5976 14.1487,17.0036 11.9997,17.0036 Z M11.9997,2.9696 C7.0207,2.9696 2.9697,7.0206 2.9697,11.9996 C2.9697,14.3036 3.8437,16.4026 5.2697,17.9996 C7.2737,16.6976 9.5917,16.0036 11.9997,16.0036 C14.4137,16.0036 16.7257,16.6976 18.7307,17.9996 C20.1567,16.4036 21.0307,14.3046 21.0307,11.9996 C21.0307,7.0206 16.9797,2.9696 11.9997,2.9696 Z M12,5.5029 C14.479,5.5029 16.497,7.5209 16.497,9.9999 C16.497,12.4799 14.479,14.4969 12,14.4969 C9.521,14.4969 7.503,12.4799 7.503,9.9999 C7.503,7.5209 9.521,5.5029 12,5.5029 Z M12,6.5029 C10.072,6.5029 8.503,8.0719 8.503,9.9999 C8.503,11.9279 10.072,13.4969 12,13.4969 C13.929,13.4969 15.497,11.9279 15.497,9.9999 C15.497,8.0719 13.929,6.5029 12,6.5029 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuentaOutlined);
export default __webpack_public_path__ + "static/media/cuenta-outlined.d488a364c22c302819ad66c14465edb5.svg";
export { ForwardRef as ReactComponent };